import { config } from '@/config/config';
import {
  clearLinkedInSigninState,
  completeLinkedInLoginFromCallback,
  LinkedInSsoError,
  readLinkedInSignInRequest,
  startLinkedInLogin,
} from '@/modules/auth/linkedinSso';
import { authProviders } from '@/modules/auth/types/externalLogin';

import { OAuthCallbackStatus } from './oauthCallbackStatus/OAuthCallbackStatus';
import {
  type OAuthCallbackAdapter,
  useOAuthCallback,
} from './oauthCallbackStatus/useOAuthCallback';

const linkedInCallback: OAuthCallbackAdapter = {
  provider: 'LinkedIn',
  ssoEvent: 'linkedInSSO',
  ssoFailureReason: 'linkedin_sso_error',
  complete: async (callbackUrl) => {
    const { code, ...request } =
      await completeLinkedInLoginFromCallback(callbackUrl);
    return {
      request,
      credentials: {
        provider: authProviders.linkedIn,
        authorizationCode: code,
        redirectUri: config.external.linkedinRedirectUri,
        idToken: null,
      },
    };
  },
  readRequest: readLinkedInSignInRequest,
  clearState: clearLinkedInSigninState,
  start: ({ returnTo, acceptTerms, intent }) =>
    startLinkedInLogin(returnTo, acceptTerms, intent),
  getSsoErrorCode: (error) =>
    error instanceof LinkedInSsoError ? error.code : undefined,
};

/** `/auth/callback/linkedin`: exchanges LinkedIn's code through the API's external login. */
export const LinkedInCallback = () => (
  <OAuthCallbackStatus
    provider="LinkedIn"
    {...useOAuthCallback(linkedInCallback)}
  />
);
